// Sign-out handler for the IAS deployment. Upstream Metabase's `dispatch(logout())`
// only clears the app-side session, which leaves the amelia SSO session alive —
// the next SSO silent check re-authenticates the user and they're signed
// straight back in. Delegating to `sso.logout()` sends the browser through
// the SSO logout endpoint; on return, `AppSsoProvider.onSignoutCallback`
// dispatches the Metabase logout to clear the app-side session cookie too.

import { useSso } from "@intelisysaviation/amelia-sso-client-react";
import { useCallback } from "react";

export const useIasSignOut = (): (() => void) => {
  const sso = useSso();
  return useCallback(() => {
    sso.logout();
  }, [sso]);
};
